// removed by extract-text-webpack-plugin
module.exports = {"message":"email-verification__message___2qbI3","button":"email-verification__button___1J-UL","title":"email-verification__title___1WOWB"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/auth/email-verification/email-verification.scss
// module id = 1246
// module chunks = 0